import React from 'react';
import { SelectProps } from '@mui/material';
import { SelectWithOptions } from './SelectWithOptions';
import { useContentFilterOptions } from '~/src/hooks/useContentFilterOptions';

export const State = React.forwardRef((props: SelectProps, ref) => {
  const { data } = useContentFilterOptions();
  const jurisdictions = data?.jurisdictions || [];

  return <SelectWithOptions ref={ref} {...props} options={jurisdictions} />;
});
